module.exports = __webpack_public_path__ + "static/10-165205336f786b2f21a20e50a0b5a9e8.jpg";